<template>
  <v-navigation-drawer
    permanent
    value
    height="auto"
    width="264"
    class="inner-drawer"
    mobile-breakpoint="1"
  >
    <div class="inner-drawer__header">
      <slot name="header"></slot>
    </div>
    <inner-drawer-list :routes="routes" icon-show />
    <div class="inner-drawer__footer">
      <slot name="footer"></slot>
    </div>
  </v-navigation-drawer>
</template>

<script>
// import { mapGetters } from 'vuex';
import { protectedRoute } from "@/router/config";
import InnerDrawerList from "@/components/InnerDrawerList.vue";

export default {
  name: "InnerDrawer",
  props: {
    routes: {
      type: Array,
      default: () => {}
    }
  },
  components: {
    InnerDrawerList
  },
  data: () => ({}),
  computed: {},
  methods: {}
};
</script>
<style lang="scss">
.inner-drawer {
  min-width: 264px !important;
  max-width: none !important;
  background: $bh-blue--4 !important;
  &__header {
    padding: 16px 24px;
  }

  .v-navigation-drawer__border {
    display: none;
  }
}
</style>
